import axios from 'axios';
import { environment } from '../environments/environment';

// Setup axios request interceptor
export function setupAxiosInterceptors() {
  axios.interceptors.request.use(
    (config) => {
      console.debug('Axios Interceptor: Intercepting request', config.url);
      console.debug('Axios Interceptor: Environment deployment type', environment.deploymentType);
      
      if (config.url && isApiRequest(config.url) && isProductionDeployment()) {
        // Modify the request config
        config.url = buildApiUrl(config.url);
        if (config.headers) {
          config.headers['Host'] = environment.apiHostHeader;
          config.headers['X-Forwarded-For'] = 'blob-storage-client';
        }
        
        console.debug('Axios Interceptor: Modified URL to', config.url);
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

function isApiRequest(url: string): boolean {
  return url.startsWith('/api/') || url.startsWith('/Content/');
}

function isProductionDeployment(): boolean {
  return environment.deploymentType === 'production' || environment.deploymentType === 'test';
}

function buildApiUrl(originalUrl: string): string {
  return `${environment.apiUrl}${originalUrl}`;
}